import React, { createContext, useState, useEffect } from 'react'

const RoleContext = createContext()

function useRole(){
    const [roleList, setRoleList] = useState([])
    const [accessControl, setAccessControl] = useState([])
    const [userRole, setUserRole] = useState('')
    
    const setAccessControls = (roles) =>{
        var accessItem = []
        roles.forEach((item)=>{
            setUserRole(item.roleName)
            item.accessControlItems.forEach((access)=>{
                if(!accessItem.some(el=>el.authority === access.authority)){
                    accessItem.push(access)
                    localStorage.setItem(access.authority, "yes")
                }
            })
        })
        
        Object.keys(localStorage).forEach((item)=>{
            if(item.startsWith("_MENU_") || item.startsWith("NEWS_")){
                if(!accessItem.some(el=>el.authority === item)){
                    localStorage.removeItem(item)
                }
            }
        })
        setAccessControl(accessItem)
    }

    const checkPermission = (prefixAuthority, suffixAuthority) =>{
        let isShow = localStorage.getItem(prefixAuthority + suffixAuthority) !== null ? true:false
        return isShow
    }

    return { roleList, setRoleList, accessControl, setAccessControls, checkPermission, userRole }
}

function RoleProvider(props) {
    const role = useRole()

    return (
        <RoleContext.Provider value={role}>
            {props.children}
        </RoleContext.Provider>
    )
}

export { RoleProvider, RoleContext }
